module.exports = __webpack_public_path__ + "static/media/status-pending.c31ad690.svg";